import { Property } from '@/types/property';
import PropertyCard from './PropertyCard';
import PropertyCardSkeleton from './PropertyCardSkeleton';
import { memo } from 'react';

interface PropertyListProps {
    properties: Property[];
    hoveredId: string | null;
    onPropertyHover: (id: string | null) => void;
    loading: boolean;
}

function PropertyListComponent({ properties, hoveredId, onPropertyHover, loading }: PropertyListProps) {
    if (loading) {
        return (
            <div className="h-full overflow-y-auto px-6 py-6">
                <div className="mb-4">
                    <div className="h-8 w-64 bg-gray-200 rounded animate-pulse mb-2"></div>
                    <div className="h-4 w-96 bg-gray-100 rounded animate-pulse"></div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-6">
                    {Array.from({ length: 6 }).map((_, i) => (
                        <PropertyCardSkeleton key={i} />
                    ))}
                </div>
            </div>
        )
    }

    if (properties.length === 0) {
        return (
            <div className="h-full flex flex-col items-center justify-center p-6 text-center">
                <h3 className="text-xl font-bold text-gray-900 mb-2">No properties found</h3>
                <p className="text-gray-500 max-w-sm">
                    We couldn't find any properties matching your current filters. Try adjusting your search criteria.
                </p>
            </div>
        );
    }

    return (
        <div className="h-full overflow-y-auto px-6 py-6" id="property-list-container">
            <div className="mb-4">
                <h2 className="text-2xl font-bold text-gray-900">
                    {properties.length} {properties.length === 1 ? 'property' : 'properties'} available
                </h2>
                <p className="text-sm text-gray-600 mt-1">
                    Explore our curated selection of holiday homes
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 pb-6">
                {properties.map((property) => (
                    <PropertyCard
                        key={property._id ?? property.id}
                        property={property}
                        isHovered={hoveredId === (property._id || property.id)}
                        onHover={() => onPropertyHover(property._id || property.id || null)}
                        onLeave={() => onPropertyHover(null)}
                    />
                ))}
            </div>
        </div>
    );
}

export default memo(PropertyListComponent);

